import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';
import { fillVerticalCode } from '../shared/fillVerticalCode';

export interface ITrackingProductPageMeta {
  item_id: string;
  item_name?: string;
  item_brand?: string;
  lead_id?: string;
  reward_campaign_name?: string;
  reward_campaign_id?: string;
  page_category: string;
  vertical_code?: string;
  step_number: string;
  step_name: string;
  experiment_id?: string;
  variant_id?: string;
}

export const createTrackingProductPageMeta = (
  parameters: ITrackingFillRewardCampaignParameters &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): ITrackingProductPageMeta => {
  const {
    items: [{ item_id, item_name, item_brand }],
  } = fillItems(parameters);

  return {
    item_id,
    item_name,
    item_brand,
    lead_id: '',
    ...fillRewardCampaign(parameters),
    step_number: '1',
    step_name: 'lead-submission',
    page_category: 'rewards page',
    ...fillVerticalCode(parameters),
  };
};
